import {
    storeNameNormalColumn,
    ownerNameNormalColumn,
    ownerPhoneNormalColumn,
    personNameNormalColumn,
    dateNormalColumn,
} from '@/components/tablePage/common/normalColumn';

// 客户管理 表头
const customerManageColumns = [
    { type: 'selection', width: 60, fixed: 'left' },
    {
        title: '门店名称',
        key: 'storeName',
        minWidth: 220,
        fixed: 'left',
        render: (h, p) => {
            const tag = h(
                'Tag',
                {
                    props: {
                        color: 'volcano',
                    },
                },
                '巡店置顶',
            );
            return h('div', { class: 'flex-vc' }, [p.row.isStoreTourTop && tag, p.row.storeName]);
        },
    },
    ownerNameNormalColumn(),
    ownerPhoneNormalColumn(),
    { title: '可用返利(元)', key: 'rebateBalance', minWidth: 130 },
    { title: '可用返利(积分)', key: 'rebateScore', minWidth: 130 },
    { title: '新零售签约', key: 'signStatusStr', minWidth: 130 },
    personNameNormalColumn('门店维护人', 'salesmanName'),
    {
        title: '标签',
        minWidth: 200,
        render: (h, p) => {
            const tags = p.row.tagList.map((item) => {
                return h(
                    'Tag',
                    {
                        props: {
                            name: item,
                            type: 'border',
                            color: 'primary',
                            closable: false,
                        },
                    },
                    item,
                );
            });
            return h('div', tags.length ? tags : '暂无标签');
        },
    },
    { title: '是否启用', key: 'isEnabledStr', minWidth: 80 },
];

// 变更字段render
const renderChangeValue = (h, value) => {
    if (!value) return h('span', '-');
    if (typeof value === 'string' && value.startsWith('http')) {
        return h(
            'div',
            {
                class: 'v-viewer-container',
                directives: [{ name: 'viewer', value: { movable: false } }],
                style: { width: '220px' },
            },
            [
                h(
                    'div',
                    {
                        class: 'mr-5 mt-2 mb-2',
                        style: {
                            position: 'relative',
                            width: '60px',
                            height: '60px',
                        },
                    },
                    [
                        h('img', {
                            class: 'v-viewer-img',
                            attrs: { src: value },
                            style: {
                                width: '60px',
                                height: '60px',
                                objectFit: 'cover',
                            },
                        }),
                        h('i', {
                            class: 'el-icon-zoom-in',
                            style: {
                                position: 'absolute',
                                bottom: '2px',
                                right: '2px',
                                color: '#fff',
                            },
                        }),
                    ],
                ),
            ],
        );
    }

    return h('span', value);
};
// 变更记录 表头
const changeRecordColumns = [
    {
        title: '变更字段',
        key: 'fieldName',
        minWidth: 180,
        render: (h, p) => [p.row.fieldName || '-'],
    },
    {
        title: '变更前值',
        minWidth: 220,
        render: (h, p) => renderChangeValue(h, p.row.beforeValue),
    },
    {
        title: '变更后值',
        minWidth: 220,
        render: (h, p) => renderChangeValue(h, p.row.afterValue),
    },
    dateNormalColumn('操作时间'),
    personNameNormalColumn('操作人', 'operatorName'),
];

export { customerManageColumns, changeRecordColumns };
